// src/components/EmptyCart.jsx
import React from "react";
import { ShoppingCart } from "lucide-react";

const EmptyCart = ({ showCountdown, countdown }) => {
  return (
    <div className="empty-cart">
      <ShoppingCart className="empty-icon" size={64} />
      <h2>Your cart is empty</h2>
      {showCountdown && (
        <div className="countdown-section">
          <p>Returning to home page in:</p>
          <div className="countdown-timer">{countdown}</div>
        </div>
      )}
    </div>
  );
};

export default EmptyCart;